export default __webpack_public_path__ + "static/media/discoverback.37e00dfb.jpg";